export const LINK_VALIDATION = '(https?://)([\\da-z-]+\\.)+([a-z]{2,})(?=[/:#?\\s]|$)([-a-zA-Z0-9@:%_+.~#?&//=]*)';
